/** * 登录 */
<template>
  <div class="login-wrap">
    <el-form
      label-position="left"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="0px"
      class="flex alignCenter justifyBetween login-container"
    >
      <!-- <img class="loginImg" src="../assets/img/phone.png" alt="" srcset="" /> -->
      <div style="height: 550px">
        <h1 class="textCenter">
          {{ phone_pwd_flag ? "密码登录" : "短信登录" }}
        </h1>
        <h2 class="textCenter">
          请使用保e投{{ phone_pwd_flag ? "账号" : "手机号" }}进行登录
        </h2>
        <el-form-item prop="phone">
          <el-input
            type="text"
            v-model="ruleForm.phone"
            auto-complete="off"
            placeholder="手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="passWord" v-if="phone_pwd_flag">
          <el-input
            type="password"
            v-model="ruleForm.passWord"
            show-password
            auto-complete="off"
            placeholder="密码"
          ></el-input>
        </el-form-item>
        <el-row v-if="phone_pwd_flag">
          <el-col :span="12">
            <el-form-item prop="captchaCode">
              <el-input
                type="text"
                v-model="ruleForm.captchaCode"
                auto-complete="off"
                placeholder="图形验证码"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="code-box">
            <img
              :src="ruleForm.codeimg"
              alt=""
              class="codeimg"
              @click="getcode()"
            />
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col :span="12">
            <el-form-item prop="code">
              <el-input
                type="text"
                v-model="ruleForm.code"
                auto-complete="off"
                placeholder="短信验证码"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="code-box">
            <el-button
              type="primary"
              round
              :disabled="time != 0"
              style="width: 90%"
              @click="setCode"
              >{{ time == 0 ? "获取验证码" : `${time}秒` }}</el-button
            >
          </el-col>
        </el-row>
        <div class="color_C0C4CC font_size14 m_b_10">
          没有账号?忘记密码?快去保e投小程序，轻松搞定！
        </div>
        <div class="w_100 m_b_10">
          <el-button
            type="primary"
            round
            style="width: 100%"
            @click="submitForm('ruleForm')"
            >登录</el-button
          >
        </div>
        <div class="flex alignCenter">
          <el-checkbox class="m_r_10" v-model="rememberpwd"></el-checkbox>
          <div class="flex font_size12">
            <span>我已阅读并同意</span>
            <span class="color_409EFF pointer" @click="handleOpen(true)"
              >《用户协议》</span
            >
            <span>和</span>
            <span class="color_409EFF pointer" @click="handleOpen(false)"
              >《隐私政策》</span
            >
          </div>
        </div>
        <div class="textCenter" @click="phone_pwd_flag = !phone_pwd_flag">
          <p class="color_C0C4CC">其他登录方式</p>
          <img
            src="@/assets/img/phonelogin.png"
            alt=""
            style="width: 40px; height: 40px"
            v-if="phone_pwd_flag"
          />
          <img
            src="@/assets/img/set_password.png"
            alt=""
            style="width: 40px; height: 40px"
            v-else
          />
          <p>{{ phone_pwd_flag ? "短信登录" : "密码登录" }}</p>
        </div>
      </div>
    </el-form>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisable"
      width="70%"
      :close-on-click-modal="false"
      @close="dialogVisable = false"
    >
      <div v-html="showData"></div>
    </el-dialog>
  </div>
</template>
<script type="text/ecmascript-6">
import { setCookie, getCookie, delCookie,vTelNum } from '../utils/util'
import {doLogin,getCaptchaCode,sendVerification,loginByCode,getProtocol} from '@/api/login/index'
import md5 from 'js-md5'
export default {
  data() {
    return {
      //协议，条款
      dialogVisable:false,
      title:'',
      ProtocolData:{},
      showData:'',
      phone_pwd_flag: true,
      time: 0,
      // 阅读条款
      rememberpwd: false,
      ruleForm: {
        phone: '',
        passWord: '',
      },
      //rules前端验证
      rules: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        passWord: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        captchaCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        code:[{ required: true, message: '请输入短信验证码', trigger: 'blur' }],
      }
    }
  },
  mounted(){
      const height = document.body.scrollHeight || document.documentElement.scrollHeight
      console.log('height',height)
      window.parent.postMessage({
        type: 'iframeHeight',
        height: height + 20 // +20 是为了留点边距
      }, '*') // * 表示允许发送给任何 origin，生产环境建议指定域名
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取存在本地的用户名密码
    this.getuserpwd()
    this.getcode()
    this.getProtocol()
  },
  // 里面的函数只有调用才会执行
  methods: {
    remember() {

    },
    //获取用户协议
    getProtocol(){
      getProtocol(res=>{
        this.ProtocolData=res
      })
    },
    handleOpen(flag){
      flag?this.showData=this.ProtocolData.userProtocol:this.showData=this.ProtocolData.privacyProtocol
      this.dialogVisable=true
    },
    timerFun() {
    	this.timer = setInterval(() => {
    		this.time--
    		if (this.time === 0) {
    			clearInterval(this.timer)
    		}
    	}, 1000)
    },
    // 发送短信
    setCode() {
      if (!this.ruleForm.phone) return this.$message.error('请输入手机号')
      let value = vTelNum(this.ruleForm.phone)
      if (value) return this.$message.error(value)
      if (this.time === 0) {
        this.time = 60
        this.timerFun()
      }
      sendVerification({phone:this.ruleForm.phone},res=>{
          this.$message.success(res)
      })
    },
    getcode() {
      getCaptchaCode(res => {
        this.$set( this.ruleForm,'codeimg',"data:image/gif;base64," + res.captchaImg)
        this.ruleForm.uuid = res.uuid
      })
    },
    // 获取用户名密码
    getuserpwd() {
      if (getCookie('user') != '' && getCookie('pwd') != '') {
        this.ruleForm.phone = getCookie('user')
        this.ruleForm.password = getCookie('pwd')
        this.rememberpwd = true
      }
    },
    //获取info列表
    submitForm(formName) {
      if(!this.rememberpwd){
        this.$message.error('请先阅读条款');
        return
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          if(this.phone_pwd_flag){
            let params={phone:this.ruleForm.phone,captchaCode:this.ruleForm.captchaCode,passWord:this.ruleForm.passWord,uuid:this.ruleForm.uuid}
            doLogin(params, res => {
              this.$message.success('登录成功')
              this.$store.commit('login', res.tokenValue)
              localStorage.setItem('userInfo', JSON.stringify(res.user))
              window.open(`https://bet.appbyt.com/pc/#/Home?token=${res.tokenValue}&id=${res.user.id}`, "_blank");
              // window.open(`http://10.10.0.17:8000/#/Home?token=${res.tokenValue}&id=${res.user.id}`, "_blank");
             // this.$router.push({ path: '/Home' })
            })
          }else{
            loginByCode({phone:this.ruleForm.phone,verifyCode:this.ruleForm.code},res=>{
              this.$message.success('登录成功')
              this.$store.commit('login', res.tokenValue)
              localStorage.setItem('userInfo', JSON.stringify(res.user))
              window.open(`https://bet.appbyt.com/pc/#/Home?token=${res.tokenValue}&id=${res.user.id}`, "_blank");
              //  window.open(`http://10.10.0.17:8000/#/Home?token=${res.tokenValue}&id=${res.user.id}`, "_blank");
              // this.$router.push({ path: '/Home' })
            })
          }

        } else {
          this.$message.error('请输入用户名密码！')
          return false
        }
      })
    },
  }
}
</script>

<style scoped>
.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  /* padding-top: 10%; */
  /* background-image: url("../assets/img/bg.png"); */
  /* background-color: #112346; */
  background-repeat: no-repeat;
  background-position: center right;
  background-size: 100%;
}

.login-container {
  border-radius: 10px;
  margin: 0px auto;
  width: 320px;
  padding: 50px 35px 15px 35px;
  background: #fff;
  height: 550px;
  /* border: 1px solid #eaeaea; */
  /* box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1); */
}

.remember {
  margin: 0px 0px 35px 0px;
}

.code-box {
  text-align: right;
}

.codeimg {
  width: 80%;
  height: 40px;
}
.pointer {
  cursor: pointer;
}
@media (max-width: 754px) {
  .login-container {
    width: 320px;
  }
  .login-container > img {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue